import React, {useEffect } from 'react'; 
import Header from '../Component/Header';
import Footer from '../Component/Footer'; 
import { Link } from 'react-router-dom';
function OurVision() { 
  useEffect(() => {
    document.title = 'Our Vision -  Mercy Memorial School, Kanpur';  
}, []); 
  return (
    <>   
      <Header />
      <div className="sliderbg"></div>
      <div className="innerpage">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <ul className="breadcrumbli">
                <li><Link to="/"> Home </Link></li>
                <li>About Us</li>
                <li>Our Vision</li>
              </ul>
            </div> 
            <div className="col-lg-12">
              <h2 className="innerheading">Our Vision</h2>
            </div>
          </div> 
          <div className="row">
               <div className="col-lg-12">
                <p>Our institution has been shaped and guided by a remarkable group of visionaries whose leadership, dedication and unwavering commitment to education have laid the foundation for its success.</p>
               <p><b><i>“Our past is our strength, the present –our courage and the future - our hope”</i></b></p> 
              </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default OurVision;
